import { useMedicalChronology } from "@/components/MedicalChronology/contexts/MedicalChronologyContext";
import { useCanCompareVersions } from "@/permissions/v2/cases";
import { useChronologyCompareVersionsStore } from "@/store/chronologyCompareVersionsStore";
import React from "react";

import { VersionDropdown } from "./VersionDropdown";

export interface VersionDropdownSlotProps {
  /** Drop the "Version" label so the identifying name/date gets the width instead of truncating to "V…". */
  compact?: boolean;
}

export const VersionDropdownSlot: React.FC<VersionDropdownSlotProps> = ({ compact = false }) => {
  const {
    versions,
    selectedVersionId,
    currentVersion,
    isVersionActionLoading,
    setSelectedVersionId,
    openVersionNameModal,
    setVersionAsCurrent,
    duplicateVersion,
    deleteVersion,
    firmContext,
    isFinishedCaseReadOnly,
  } = useMedicalChronology();
  const openComparePicker = useChronologyCompareVersionsStore((s) => s.openComparePicker);

  const canCompare = useCanCompareVersions(firmContext?.firmId);

  return (
    <VersionDropdown
      versions={versions}
      selectedVersionId={selectedVersionId}
      currentVersion={currentVersion}
      isLoading={isVersionActionLoading}
      onVersionChange={setSelectedVersionId}
      onEditName={openVersionNameModal}
      onSetCurrent={setVersionAsCurrent}
      onDuplicate={duplicateVersion}
      onDelete={deleteVersion}
      onCompare={openComparePicker}
      canCompare={canCompare}
      canManageVersions={!isFinishedCaseReadOnly}
      compact={compact}
    />
  );
};
